import React, { useEffect, useState } from 'react';

import { VisitorIdentification, isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import Helmet from 'react-helmet';
import * as gigya from './utils/gigyaScreen';
import './assets/app.css';
import layout from './constants/layoutConstants';
import {
  fetchSponsor,
  fetchSponsorOnResize,
  setHelpResults,
  userLoginStatus,
} from './actions/sponsorAction';
import { useSponsorValue } from './context/sponsorContext';
import loadable from '@loadable/component';
import PushNotification from './components/Common/PushNotification';
import GigyaInit from './components/Common/GigyaInit';
import HomeLayout from './layouts/HomeLayout';
import TemplateLayout from './layouts/TemplateLayout';
import MasterClientLayout from './layouts/MasterClientLayout';
import MutvLayout from './layouts/MutvLayout';
import { focusHighlighter } from './utils/focusHighlighter';
import OgTag from './components/Common/OgTag';
import { TwitterWidgetInit } from './lib/TwitterPlugin';
import DnsPrefetch from './components/Common/DnsPrefetch';
import NewsDetailLayout from './layouts/NewsDetailLayout';
import {
  isApp,
  getCMWHelp,
  isCollection,
  getCookie,
  getParameterByName,
  unhandledRejectionHandler,
  unhandledErrorHandler,
  getFavPlayerRedirectUrl,
  isCompetitionDetailOnApp,
} from './utils/utils';
import MU from './constants/muConstants';
import CookiePolicy from './components/Common/CookiePolicy/CookiePolicy';
import { THRESHOLD } from './constants/globalConstants';
import Kameleoon from './components/Common/Kameleoon';
import CapchaInit from './components/Common/CaptchaInit';
import { insertAdobeScript } from './lib/AdobeAnalyticsPlugin';
import { errorHandler, loginEventHandler, setUserVerfication } from './utils/gigyaScreen';
import { useModal } from './components/Common/Modal';
import DeviceManagerModal from './components/Mutv/DeviceManagerModal';
import {
  checkIDMFlow,
  afterLogout,
  redirectToIDMLogin,
  fetchUserInfo,
  fetchIDMToken,
  getNewToken,
  getUserData,
  userDataExpireTime,
  removeUserData,
  IDMSuccessCallback,
  createBaseUrl,
  IDMSuccessScroll,
  saveUserIDCookie,
  removeUserIDCookie,
  getIDMCookie,
  handleUserinfoAnalytics,
} from './utils/idmUtils';
import { userData } from './userInfoData.js';
import { calculateAge } from './utils/utils';
import { callBraze, isCookiesSelected } from './utils/brazeUtil';
import Loader from './components/Common/Loader.js';
import { logoutComplete } from './utils/analytics.js';
import CalendarModal from './components/Modals/CalendarModal.js';
import {
  AddToCalendarButtons,
  appleShortAddtoCalendar,
  calendarHeadline,
  fixtureCalendarHeadline,
  getFixtureConfiguration,
  getFixtureTeam,
  googleShortAddtoCalendar,
  noteDescription,
  noteHeadline,
  outlookShortAddtoCalendar,
} from './utils/reminderUtils.js';

const StructuredData = loadable(() => import('./components/StructuredData'));
let timeoutId;
/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

/*
  APP LAYOUT
  This is where the app's HTML structure and root placeholders should be defined.

  All routes share this root layout by default (this could be customized in RouteHandler),
  but components added to inner placeholders are route-specific.
*/

const renderLayout = (route, context) => {
  let LayoutDom;
  switch (route.layoutId) {
    case layout.CLIENT_LAYOUT: {
      LayoutDom = MasterClientLayout;
      break;
    }
    case layout.TEMPLATE_LAYOUT: {
      LayoutDom = TemplateLayout;
      break;
    }
    case layout.HOME_LAYOUT: {
      LayoutDom = HomeLayout;
      break;
    }
    case layout.NEWS_DETAIL_LAYOUT: {
      LayoutDom = NewsDetailLayout;
      break;
    }
    case layout.MUTV_LAYOUT: {
      LayoutDom = MutvLayout;
      break;
    }
    default:
      LayoutDom = TemplateLayout;
  }
  return LayoutDom ? <LayoutDom route={route} context={context} /> : null;
};

const Layout = ({ route, context }) => {
  const [
    {
      isGigyaAvilable,
      isUserLogin,
      isLoginChecked,
      deviceSynclimitReached,
      deviceInfo,
      continueOnOther,
      playHere,
      userLoginDetail,
    },
    dispatch,
  ] = useSponsorValue();
  const { showModal, closeModal, isModalVisible } = useModal();
  const {
    showModal: calendarShowModal,
    closeModal: calendarCloseModal,
    isModalVisible: calendarModalVisible,
  } = useModal();
  const layoutId = route && route.layoutId;
  const [showIDMLoader, setShowIDMLoader] = useState(false);

  // IDM login using PKCE
  const retriveSuccessCallback = typeof window !== 'undefined' && getParameterByName('state', true);
  const code = typeof window !== 'undefined' && getParameterByName('code', true);
  if (code) {
    sessionStorage.setItem('idm_code', code);
  }
  // using URL string ?page=calendar&teamtype=First%20Team open Calendar Modal
  const enableCalendar = MU?.eventCalendar?.enableCalendar;
  const fixtureTeamName = () => {
    const myTeam = getParameterByName('teamtype', true);
    if (myTeam) {
      return getFixtureTeam(myTeam);
    } else return '';
  };
  const configData = () => {
    const myTeam = getParameterByName('teamtype', true);
    const getLevelData = getFixtureConfiguration(myTeam);
    if (getLevelData) {
      return getLevelData;
    } else return '';
  };
  const currentPage = route && route.name;
  const notification = context?.Notification;

  useEffect(() => {
    getFavPlayerRedirectUrl();
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && window) {
      if (!retriveSuccessCallback) checkIDMFlow(isUserLogin);
      const isCalendarModal = typeof window !== 'undefined' && getParameterByName('page', true);
      if (isCalendarModal && isCalendarModal === 'calendar' && !calendarModalVisible) {
        calendarShowModal();
      }
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && window) {
      !isApp() &&
        isLoginChecked &&
        !isUserLogin &&
        isCookiesSelected() &&
        callBraze('', notification, currentPage);
    }
  }, [isLoginChecked]);

  useEffect(() => {
    if (retriveSuccessCallback === 'web_tv') {
      setShowIDMLoader(true);
    }
  }, [retriveSuccessCallback]);

  useEffect(() => {
    fetchSponsor(dispatch);
    focusHighlighter();
    TwitterWidgetInit();
    setLangProp();
    if (isApp()) {
      const userConsent_off = getCookie('userConsentCookiePolicy') === 'off';
      if (!userConsent_off) {
        insertAdobeScript(layoutId);
      }
      !isCollection() && setMUHelpData();
    }
  }, []);

  useEffect(() => {
    window.addEventListener('resize', onResizeListner);
    window.addEventListener('unhandledrejection', unhandledRejectionHandler);
    window.addEventListener('error', unhandledErrorHandler);
    return () => {
      window.removeEventListener('resize', onResizeListner);
      window.removeEventListener('unhandledrejection', unhandledRejectionHandler);
      window.removeEventListener('error', unhandledErrorHandler);
    };
  }, []);

  useEffect(() => {
    if (isGigyaAvilable) {
      setUserVerfication();
      loginHandler();
      if (
        (!isUserLogin && (!code || retriveSuccessCallback)) ||
        isCompetitionDetailOnApp(userLoginDetail)
      ) {
        getLoginDetail();
      }
    }
  }, [isGigyaAvilable, userLoginDetail, isUserLogin]);

  useEffect(() => {
    !playHere && closeModal();
  }, [playHere]);

  useEffect(() => {
    !continueOnOther && closeModal();
  }, [continueOnOther]);

  useEffect(() => {
    const deviceId = localStorage.getItem('deviceID') && localStorage.getItem('deviceID');
    const deviceCheck =
      deviceSynclimitReached && deviceId && deviceInfo && deviceInfo.deviceId != deviceId;
    deviceCheck && showModal('', true);
  }, [deviceSynclimitReached, deviceInfo]);

  const getLoginDetail = () => {
    if (!MU.isIDMEnabled) {
      //for Gigya login
      if (window.gigya) {
        var accountInfoResponse = function (response) {
          if (response.errorCode === 0) {
            // save userID/gigyaID (sub) into cookie
            saveUserIDCookie(response?.UID);
            userLoginStatus(dispatch, response);
            !isApp() && isCookiesSelected() && callBraze(response, notification, currentPage);
          } else {
            userLoginStatus(dispatch, false);
            errorHandler(response);
          }
        };
        window.gigya && window.gigya.accounts.getAccountInfo({ callback: accountInfoResponse });
      }
    } else if (!isEditorActive()) {
      //for IDM login
      const manutdUID = getIDMCookie('manutd_uid');
      if (manutdUID) {
        window.gigya.accounts.logout({
          callback: function onLogout(response) {
            logoutComplete(response);
            if (response && response.errorCode === 0) {
              localStorage && localStorage.removeItem('deviceID');
              localStorage && localStorage.removeItem('apiSessionID');
              sessionStorage && sessionStorage.removeItem('keysObj');
              removeUserIDCookie();
              loginIDMHandler();
            }
          },
        });
      } else {
        loginIDMHandler();
      }
    }
  };

  const loginIDMHandler = () => {
    const manutdAuth = getIDMCookie('manutd_auth');
    const idmCode = sessionStorage.getItem('idm_code');
    if (!idmCode && !manutdAuth) userLoginStatus(dispatch, false);
    if (idmCode) {
      getIDMTokenRoute();
    } else if (manutdAuth) {
      redirectToIDMLogin('page_refresh');
    }
  };

  const getIDMTokenRoute = () => {
    const savedCode = sessionStorage.getItem('idm_code');
    const savedAccessToken = getIDMCookie('idm_access_token');
    if (savedCode && !savedAccessToken) {
      const client_id = retriveSuccessCallback === 'web_tv' ? 'web_tv' : 'web';
      const code_verifier = sessionStorage.getItem('idm_verifier');
      const refresh_token = getIDMCookie('idm_refresh_token');
      const manutdAuth = getIDMCookie('manutd_auth');
      if (code_verifier) {
        fetchIDMToken(
          savedCode,
          fetchUserProfileInfo,
          refreshToken,
          code_verifier,
          currentPage,
          client_id
        );
      } else if (refresh_token) {
        refreshToken();
      } else if (manutdAuth) {
        redirectToIDMLogin('page_refresh');
      } else {
        if (currentPage === 'myunited') {
          redirectToIDMLogin();
        } else {
          afterLogout();
          checkIDMFlow();
          userLoginStatus(dispatch, false);
        }
      }
    } else if (savedAccessToken) {
      fetchUserProfileInfo();
    }
  };

  const refreshToken = () => {
    const refresh_token = getIDMCookie('idm_refresh_token');
    if (refresh_token) {
      const client_id = retriveSuccessCallback === 'web_tv' ? 'web_tv' : 'web';
      getNewToken(refresh_token, fetchUserProfileInfo, currentPage, client_id);
    } else if (currentPage === 'myunited') window.location = createBaseUrl();
    else {
      afterLogout();
      checkIDMFlow();
      userLoginStatus(dispatch, false);
    }
  };

  const fetchUserProfileInfo = () => {
    if (typeof window !== 'undefined' && window) {
      const manutdAuth = getIDMCookie('manutd_auth');
      const checkServer = window.location.hostname !== 'localhost' ? manutdAuth : true;
      if (checkServer) {
        var evalResponse = function (response) {
          if (response) {
            const calAge = () => {
              const birthDay = response && response.birthDay;
              const birthMonth = response && response.birthMonth;
              const birthYear = response && response.birthYear;
              const bday = `${parseInt(birthYear)}/${parseInt(birthMonth)}/${parseInt(birthDay)}`;
              if (bday) {
                return calculateAge(bday);
              } else {
                return '';
              }
            };
            const age = calAge();
            const data = userData(response, age);
            userLoginStatus(dispatch, data);
            handleUserinfoAnalytics(response);
            !isApp() && isCookiesSelected() && callBraze(data, notification, currentPage);
            if (retriveSuccessCallback) {
              //for after login successCallBack
              const successCallData = retriveSuccessCallback.split(',');
              if (successCallData[0] === 'successCallbck')
                IDMSuccessCallback(retriveSuccessCallback, data);
              if (successCallData[0] === 'successScroll')
                IDMSuccessScroll(retriveSuccessCallback, data);
              //for MUTV subscription step_2
              if (retriveSuccessCallback === 'web_tv') {
                if (data && data.UID) {
                  gigya.addSubscription({
                    param: data.UID,
                    token: 'uid',
                    isNewUser: true,
                  });
                }
              }
            }
          } else {
            userLoginStatus(dispatch, false);
            errorHandler(response);
            afterLogout();
          }
        };
        const savedAccessToken = getIDMCookie('idm_access_token');
        if (savedAccessToken) {
          const userDataLogOutTime =
            route &&
            route.fields &&
            route.fields.IDMPageRefreshTimeInterval &&
            route.fields.IDMPageRefreshTimeInterval.value &&
            route.fields.IDMPageRefreshTimeInterval.value;
          const timeToCheckExpire = userDataExpireTime(currentPage, userDataLogOutTime);
          const userDataTime = getUserData('userInfo_time');
          if (userDataTime) {
            const expireIn = userDataTime + timeToCheckExpire * 60 * 1000;
            const timeNow = Date.now();
            if (expireIn < timeNow) {
              removeUserData();
            }
          }
          const userDataLocal = getUserData(isApp() ? 'vyaktigat' : 'userInfo');
          if (userDataLocal) {
            evalResponse(userDataLocal);
          } else {
            fetchUserInfo(savedAccessToken, evalResponse, refreshToken);
          }
        } else if (currentPage === 'myunited') {
          window.location = createBaseUrl();
        } else {
          afterLogout();
          checkIDMFlow();
          userLoginStatus(dispatch, false);
        }
      } else {
        afterLogout();
        userLoginStatus(dispatch, false);
      }
    }
  };

  // prettier-ignore
  const setMUHelpData = () => {
    // eslint-disable-next-line
    function _0x401b() { const _0x23a2ea = ['92892kHYFMW', '6686379kBpYDR', 'log', 'helpMenuDet', '14FUKCXW', 'helpMenu', '3099824FePXWW', '4980582GQfoix', 'webkit', 'messageHandlers', '83192pApbQv', 'postMessage', '1181665ZkRxUR', 'errwv', 'postHelp', '375KtEUJP', 'MUhelp', 'setMU', '2591952DGWdgU']; _0x401b = function () { return _0x23a2ea; }; return _0x401b(); } const _0x18cd9d = _0x553d; (function (_0xbaab99, _0x204b8f) { const _0x373020 = _0x553d, _0x597a03 = _0xbaab99(); while (!![]) { try { const _0x4e71f2 = parseInt(_0x373020(0x16c)) / 0x1 + -parseInt(_0x373020(0x166)) / 0x2 + -parseInt(_0x373020(0x167)) / 0x3 + parseInt(_0x373020(0x160)) / 0x4 * (parseInt(_0x373020(0x15c)) / 0x5) + parseInt(_0x373020(0x15f)) / 0x6 + -parseInt(_0x373020(0x164)) / 0x7 * (-parseInt(_0x373020(0x16a)) / 0x8) + parseInt(_0x373020(0x161)) / 0x9; if (_0x4e71f2 === _0x204b8f) break; else _0x597a03['push'](_0x597a03['shift']()); } catch (_0x5af53a) { _0x597a03['push'](_0x597a03['shift']()); } } }(_0x401b, 0xddecd)); function _0x553d(_0x596496, _0x305b6c) { const _0x401b1f = _0x401b(); return _0x553d = function (_0x553d28, _0x3cccf2) { _0x553d28 = _0x553d28 - 0x15b; let _0x5d0d5f = _0x401b1f[_0x553d28]; return _0x5d0d5f; }, _0x553d(_0x596496, _0x305b6c); } if (window[_0x18cd9d(0x15d)]) { const helpResults = window[_0x18cd9d(0x15d)][_0x18cd9d(0x165)](); helpResults && setHelpResults(dispatch, JSON['parse'](helpResults)); } else { if (window[_0x18cd9d(0x168)] && window[_0x18cd9d(0x168)][_0x18cd9d(0x169)] && window[_0x18cd9d(0x168)][_0x18cd9d(0x169)][_0x18cd9d(0x15b)] && window[_0x18cd9d(0x168)][_0x18cd9d(0x169)][_0x18cd9d(0x15b)][_0x18cd9d(0x16b)]) { window[_0x18cd9d(0x163)] = function helpMenuDet(_0x5b52c8) { _0x5b52c8 && setHelpResults(dispatch, _0x5b52c8); }; try { window['webkit'][_0x18cd9d(0x169)][_0x18cd9d(0x15b)][_0x18cd9d(0x16b)]('wv'); } catch (_0x5c8580) { console[_0x18cd9d(0x162)](_0x18cd9d(0x16d)); } } else { const isMWV = getCMWHelp(); MU[_0x18cd9d(0x15e)]({ 'isMWV': isMWV }); isMWV && setHelpResults(dispatch, {}); } }
  };
  const loginHandler = () => {
    window.gigya &&
      window.gigya.accounts &&
      window.gigya.accounts.addEventHandlers({
        onLogin: loginEventHandler,
      });
  };
  const onResizeListner = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fetchSponsorOnResize(dispatch);
    }, THRESHOLD);
  };
  const setLangProp = () => {
    const htmlElm = document && document.querySelector('html');
    htmlElm && MU && htmlElm.setAttribute('lang', MU.language);
  };

  return (
    <React.Fragment>
      {(typeof window === 'undefined' || process.env.NODE_ENV === 'development') && (
        <React.Fragment>
          <Helmet>
            <meta charset="utf-8" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

            {isApp() && route && route.layoutId === layout.NEWS_DETAIL_LAYOUT ? (
              <meta
                name="viewport"
                content="width=device-width, initial-scale=1, viewport-fit=cover"
              />
            ) : (
              <meta name="viewport" content="width=device-width, initial-scale=1" />
            )}
            <meta name="apple-mobile-web-app-status-bar-style" content="#c70101" />
            <meta content="on" httpEquiv="x-dns-prefetch-control" />
            <link
              rel="apple-touch-icon"
              sizes="180x180"
              href="/Assets/images/favicons/apple-touch-icon.png"
            />
            <link
              rel="icon"
              type="image/png"
              sizes="32x32"
              href="/Assets/images/favicons/favicon-32x32.png"
            />
            <link
              rel="icon"
              type="image/png"
              sizes="16x16"
              href="/Assets/images/favicons/favicon-16x16.png"
            />
            <link rel="manifest" href="/Assets/images/favicons/manifest.json"></link>

            {MU.jsencryptUrl && (
              <script type="text/javascript" src={MU.jsencryptUrl} async></script>
            )}
            {MU.isTeamViewerEnable && MU.isActiveTeamViewer && MU.teamViewerScriptUrl && (
              <script src={MU.teamViewerScriptUrl} type="text/javascript" async></script>
            )}
            <script type="text/javascript">
              {`window.DDO={}; window.onerror=function(e){console.log(e);return false;}`}
            </script>
            {((context && !context?.SEO?.opengraph?.loadBodyScript) ||
              !MU.isCurrentGeoinConsentList) && (
              <script src="//www.googletagservices.com/tag/js/gpt.js" async></script>
            )}
          </Helmet>
          {context &&
            context.MU &&
            context.MU.kameleoonIframeURL &&
            context.MU.kameleoonReferenceScript && (
              <Kameleoon
                iframeURL={context.MU.kameleoonIframeURL}
                kameleoonReferenceScript={context.MU.kameleoonReferenceScript}
              />
            )}
          {context && context.SEO && context.SEO.opengraph && (
            <OgTag item={context.SEO.opengraph} />
          )}
          <DnsPrefetch />
          {context && context.SEO && (
            <StructuredData structuredData={context.SEO} fields={route.fields}></StructuredData>
          )}
        </React.Fragment>
      )}
      {typeof window !== 'undefined' && (
        <Helmet>
          {/* For Gigya screens and cookie policy*/}
          <script type="text/javascript">
            {`function redirectToOrigin() {
                window.location = "${window.location.origin}/${MU.language ? MU.language : 'en'}";
              }
              function manageSettings() {
                var cookieButton = document.querySelector('#showconsenthidden');
                if(cookieButton){
                  cookieButton.click();
                }
            }
            function TWCobrowse() {
              if(window.CV && window.CV.cobrowse && !window.CV.cobrowse.sessionIsActive()){
                CV.cobrowse.start();
              }
          }`}
          </script>
        </Helmet>
      )}
      {/*
      VisitorIdentification is necessary for Sitecore Analytics to determine if the visitor is a robot.
      If Sitecore XP (with xConnect/xDB) is used, this is required or else analytics will not be collected for the JSS app.
      For XM (CMS-only) apps, this should be removed.

      VI detection only runs once for a given analytics ID, so this is not a recurring operation once cookies are established.
    */}
      <VisitorIdentification />
      <div id="modal-root"></div>
      <div id="modal-popUp"></div>
      {typeof window !== 'undefined' && !isApp() && !isEditorActive() && (
        <CookiePolicy
          context={context}
          layoutId={route && route.layoutId}
          currentPage={currentPage}
        />
      )}
      {isLoginChecked && context && context.Notification && !isApp() && !isEditorActive() && (
        <PushNotification item={context.Notification}></PushNotification>
      )}
      <GigyaInit dispatch={dispatch} />
      {!isApp() && <CapchaInit dispatch={dispatch} />}
      {renderLayout(route, context)}
      {isModalVisible && (
        <DeviceManagerModal
          dispatch={dispatch}
          closeModal={closeModal}
          UID={userLoginDetail && userLoginDetail.UID}
          deviceInfo={deviceInfo}
          deviceSynclimitReached={deviceSynclimitReached}
          deviceID={localStorage.getItem('deviceID')}
          previousActiveElement={document && document.querySelector('div .page-wrap')}
        />
      )}
      {calendarModalVisible && enableCalendar && (
        <CalendarModal
          fallback={<Loader />}
          AddToCalendarButtons={AddToCalendarButtons}
          closeModal={calendarCloseModal}
          calendarTitle={fixtureTeamName()}
          fixtureCalendarHeadline={fixtureCalendarHeadline()}
          calendarHeadline={calendarHeadline()}
          noteHeadline={noteHeadline()}
          noteDescription={noteDescription()}
          appleShortAddtoCalendar={appleShortAddtoCalendar()}
          googleShortAddtoCalendar={googleShortAddtoCalendar()}
          outlookShortAddtoCalendar={outlookShortAddtoCalendar()}
          configData={configData()}
          isFixtureCard={true}
        ></CalendarModal>
      )}
      {showIDMLoader && <Loader style={{ zIndex: 9999999, background: '#1A1A1A' }} />}
    </React.Fragment>
  );
};

export default Layout;
